export const choghadiyaLines = [
  'Harness the power of auspicious moments and unlock new opportunities in your journey. 🌟🚀',
  'May each Choghadiya bring prosperity and joy into your life. 🙏✨',
  'Align your actions with cosmic harmony and experience a day of positive energy. 🌌🌞',
  'As you move into a new home, let these timings bless your space with happiness and love. 🏠❤️',
  'Let your important ceremonies be graced by the divine energies of Choghadiya. 💍🌠',
  'Wishing you a safe and blessed journey as you travel under the guidance of auspicious timings. ✈️🌅',
  'Embrace the divine rhythm of time, and may each moment unfold with divine blessings. 🌈🕊️',
  'May the celestial clockwork of Choghadiya lead you towards your destined path. 🌌⌛',
  'Infuse your day with spiritual significance as you follow the sacred Choghadiya Timings. 🕉️🌸',
  'May the cosmic alignment bestow abundance and harmony in all your endeavors. 🌌🌺',
  'Let the auspicious aura of Choghadiya enrich your life with peace and contentment. 🙏🌅',
  'With every passing moment of Choghadiya, may you feel guided and protected. 🌠🌿',
  'May the divine energy of these timings ignite a sense of purpose and fulfillment within you. 🌟🔥',
  'As you cherish each Choghadiya, may your heart be filled with gratitude and love. ❤️🕊️',
  "Wishing you a day of spiritual awakening and self-discovery under the Choghadiya's blessings. 🌞🧘‍♂️",
  'May the sacred hours of Choghadiya bless your decisions and actions with wisdom. 🌌🌈',
  "Allow the mystical Choghadiya Timings to be your guide through life's transitions. 🌌⏳",
  'May the essence of these auspicious hours infuse your soul with tranquility and serenity. 🌼🌠',
  'Embrace the timeless wisdom of Choghadiya as you create memorable moments today. 📲🎉',
  'Let the divine blessings of Choghadiya illuminate your path towards success and fulfillment. ✨🚀',
  'May the sacred rhythm of Choghadiya inspire you to embrace every moment with gratitude. 🕊️🌞',
  'Unlock the door to prosperity as you follow the divine Choghadiya Timings. 🗝️💰',
  "With the blessings of Choghadiya, may you find harmony amidst life's complexities. 🌌🧭",
  'Embrace the mystical flow of time and experience the magic of these auspicious hours. ✨⌛',
  'May the Choghadiya moments bring you closer to your dreams and aspirations. 🌟💭',
  'Let each Choghadiya be a stepping stone towards your personal and spiritual growth. 🌌🚶‍♀️',
  'May the divine blessings of Choghadiya shower you with abundance and prosperity. 🌟💫',
  'Let the rhythm of Choghadiya harmonize your actions with the universe. 🌌🎶',
  'With each auspicious moment, may you find strength and courage to overcome challenges. 💪🌠',
  'May the sacred Choghadiya instill a sense of clarity and focus in your endeavors. 🌌🔍',
  'Embrace the divine guidance of Choghadiya and let your intuition lead the way. 🙏💡',
  'May the journey of today be guided by the celestial clockwork of Choghadiya. 🌠⏰',
  'Let the blessings of auspicious timings infuse your day with positivity and harmony. 🌞🕊️',
];

type FlagMap = {
  [countryName: string]: string;
};

export const getCountryFlagEmoji = (countryName: string = '') => {
  const flagMap: FlagMap = {
    India: '🇮🇳', // India (Significant Jain population)
    'United Kingdom': '🇬🇧', // United Kingdom (Has Jain communities)
    'United States of America': '🇺🇸', // United States (Has Jain communities)
    Canada: '🇨🇦', // Canada (Has Jain communities)
    Australia: '🇦🇺', // Australia (Has Jain communities)
    Singapore: '🇸🇬', // Singapore (Has Jain communities)
    Malaysia: '🇲🇾', // Malaysia (Has Jain communities)
    Thailand: '🇹🇭', // Thailand (Has Jain communities)
    'United Arab Emirates': '🇦🇪', // United Arab Emirates (Has Jain communities)
    'Hong Kong': '🇭🇰', // Hong Kong (Has Jain communities)
    Kenya: '🇰🇪', // Kenya (Has Jain communities)
    Tanzania: '🇹🇿', // Tanzania (Has Jain communities)
    Uganda: '🇺🇬', // Uganda (Has Jain communities)
    'South Africa': '🇿🇦', // South Africa (Has Jain communities)
    // Add more countries and their flag emojis here
  };

  return flagMap[countryName] || '🌍'; // Return the flag emoji for the given country name, or 🌍 as a default
};
